import script from "./_hc-search.vue?vue&type=script&lang=ts&setup=true"
export * from "./_hc-search.vue?vue&type=script&lang=ts&setup=true"

import "./_hc-search.vue?vue&type=style&index=0&id=781e8bf7&lang=scss"

const __exports__ = script;

export default __exports__